module.exports = __webpack_public_path__ + "media/assets/images/blog/elettronic_board-small-fdb7995b19cffabfb4c98359f374f4e3.jpeg";